import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../../components/Layout'
import Img from 'gatsby-image'
import { graphql, Link } from 'gatsby'

import CTA from '../../components/CTA'

import {
  Announcement,
  Container,
  Hero,
  HeroContent,
  HeroFigure,
  HeroMain,
  Text,
  ServiceCard
} from '../../components/styles'
import { Button } from '../../components/Button'
import FAQs from '../../components/FAQs'
import Form from '../../components/Form'
import { SocialCases } from '../../components/case-studies/SocialCases'
import Arrow from '../../components/Arrow'
import Testimonials from '../../components/Testimonials'
import { testimonials } from '../testimonials'
import { Helmet } from 'react-helmet'

export const faqsInfo = [
  {
    title: 'Common social media questions'
  },
  {
    answer: `Every day, we help businesses in every industry and of every size get more traffic, more conversion and a radical increase in sales and high quality customers. We're proud of our track record of producing great tangible results for our partners.`,
    question: 'Does social media work?'
  },
  {
    answer: `Your business is one of a kind, and there are many factors at play. Each platform comes with it's own unique benefits and primary demographics. The channels that are most suited to your business needs depends entirely on your strategy and goals. That being said, we always recommend the two biggest social media platforms in the world: Facebook, and Instagram.`,
    question: `Which social media channels are best for my business?`
  },
  {
    answer: `Of course. Our regular reporting will keep you up to date on the metrics you care about. You'll recieve information on the impacts of our content marketing and organic efforts and exact numbers for social advertising reults. We strive to be transparent in everything we do.`,
    question: `Will you be able to prove your social media ROI?`
  },
  {
    answer: `Well, strategy is number one! Following this we're experts in execution: graphic design, writing, content delivery, landing page creation, website optimisations, social competitions, and post curation are all in our reach. We'll pick what's best for you business and pursue it relentlessly.`,
    question: `What kind of social media work can we expect from you?`
  }
]

/* prettier-ignore */
interface IProps {
  data: {
    audit: {
      childImageSharp: {
        fluid: object
      }
    };
    soh: {
      childImageSharp: {
        fluid: object
      }
    };
    setup: {
      childImageSharp: {
        fluid: object
      }
    };
    hero: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout>
    <Helmet>
      <title>Digital Remarketing - Online Retargeting Ads - Turboclicks</title>
      <meta
        name="description"
        content="See the power of digital remarketing advertising. Use remarketing to double your business sales and regain lost leads."
      />
    </Helmet>
    <Hero>
      <Container>
        <HeroContent>
          <HeroMain>
            <h1>Strategic Remarketing</h1>
            <p>
              You are being tracked. We all know this, and yet so few of us are
              taking advantage of it.
            </p>
            <Announcement to="/contact">
              Speak with a specialist
              <Arrow rotate="-90deg" />
            </Announcement>
            <Link to="/contact#form">
              <Button inverted={true}>Talk to us about remarketing</Button>
            </Link>
          </HeroMain>

          <HeroFigure>
            <Img
              fluid={data.hero.childImageSharp.fluid}
              alt="Remarketing and retargeting services"
            />
          </HeroFigure>
        </HeroContent>
      </Container>
    </Hero>

    <Container
      bg="#f1f8fe"
      padY={true}
      medium={true}
      style={{ borderRadius: 4 }}
    >
      <Flex mb={5} justifyContent="center">
        <h4>Remarketing Services</h4>
      </Flex>
      <ServiceCard color="primary">
        <img
          src="//truework.com/images/line-illustrations/background-check-056dd30e.svg"
          alt="Mortgage illustration"
        />
        <div>
          <h3>Social Remarketing</h3>
          <p>
            You know, over 35% of Australians check their social media accounts
            more than 5 times per day? Just imagine if you could get your
            business in front of eager customers 5 times per day every single
            day. It's a modern day super power. Don't miss out, give us an
            obligation free call today.
          </p>
        </div>
      </ServiceCard>
      <ServiceCard color="tertiary">
        <img
          src="//truework.com/images/line-illustrations/mortgage-734d5e32.svg"
          alt="Mortgage illustration"
        />
        <div>
          <h3>Google Remarketing</h3>
          <p>
            Take the biggest search engine in the world (Google), now take the
            biggest video platform in the world (YouTube), chuck in a few
            million other blogs and websites. This is the reach you've got with
            Google Remarketing Display &amp; Video Ads. Basically, you can
            target anyone, anywhere. And this is just the start.
          </p>
        </div>
      </ServiceCard>
      <ServiceCard color="purple">
        <img
          src="//truework.com/images/line-illustrations/background-check-056dd30e.svg"
          alt="Mortgage illustration"
        />
        <div>
          <h3>Traffic driving</h3>
          <p>
            Remarketing is just a part of an overall strategy, we're not here to
            tell you this will fix all your troubles but with the right traffic
            generation plan and remarketing strategies working together there is
            no doubt that your business will grow.
          </p>
        </div>
      </ServiceCard>
    </Container>

    <Box mt={5} />

    <CTA
      inverted={true}
      title="Don't miss this opportunity"
      subtitle="There is still untapped potential"
      button="Speak to a specialist"
    />

    <Container medium={true} padY={true}>
      <h3>The power of remarketing</h3>

      <h5>It's effectiveness</h5>
      <Text size="large">
        Remarketing (or retargeting) is a highly effective form of digital
        advertising. And the reason it simple... Your focusing all your efforts
        on qualified leads who have already demonstrated some interest in your
        business. A greater click-through rate, more conversions and a high
        number of sales that would have otherwise gone to your competitors are
        just a few of the simple.
      </Text>

      <h5>Holistic strategy</h5>
      <Text size="large">
        Although this is undeniably a powerful tool it simply will not be
        helpful in and of itself. Remarketing is not going to drive new traffic
        to your website, or produce brand new sales. It will simply take
        prospects from being on the line, to closed deals.
      </Text>
      <Text size="large">
        At Turboclicks, our focus is not just on remarketing. We diversify our
        skill set and efforts across a wide range of digital marketing mediums.
        This will allow us to help not only close prospects, but to generate
        brand new leads in the first place. Don't miss out on this.
      </Text>

      <h5>How does it work</h5>
      <Text size="large">
        We can get started by simply placing a piece of code (known as a pixel)
        on your website. It does not effect website performance and is visitors
        will not know it is there. From there the third party partner
        advertisers, for example, Facebook, LinkedIn, Google, etc. can then show
        our very own ads related to the pages they have visited on your website!
        If you want to find out more about how our remarketing strategies can
        work for your business give us a call for an obligation-free chat today.
      </Text>

      <h5>An untapped advertising resource</h5>
      <Text size="large">
        Majority of online traffic will come across your website, click around,
        leave and then never ever return. This is a big problem, and bigger
        opportunity. With our remarketing strategies we're able to reach up to
        95% of qualified website visitors looking to buy .
      </Text>
      <Text size="large">
        Turboclicks is one of the leading remarketing providers in Australia.
      </Text>
      <Text size="large">
        Research has shown time and time again that most people need to see an
        ad, or your service, roughly 5-7 times before decision to purchase or
        follow-through. Remarketing allows you to cheaply and effectively target
        those interested in your product or service (and you) and get your
        business in front of them repeatedly to boost your conversion rate.
      </Text>
    </Container>

    <Testimonials testimonials={testimonials} />

    <Form />
  </Layout>
)

export const query = graphql`
  query RemarketingPageQuery {
    hero: file(relativePath: { eq: "remarketing-binoculars.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }

    setup: file(relativePath: { eq: "social-media-setup.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    soh: file(relativePath: { eq: "turboclicks-smartonhold-case.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    audit: file(relativePath: { eq: "brisbane-social-media-audit.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
